// AWS API Gateway-based memory storage service
class MemoryService {
  constructor() {
    this.apiEndpoint = process.env.REACT_APP_API_ENDPOINT || 'https://your-api-gateway-url/prod/memories';
  }

  // Load memories from API
  async loadMemories() {
    try {
      const response = await fetch(this.apiEndpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.memories || [];
    } catch (error) {
      console.error('Error loading memories from API:', error);
      // Return empty array instead of localStorage fallback
      return [];
    }
  }

  // Add a new memory via API
  async addMemory(memoryData, password) {
    try {
      const response = await fetch(this.apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          password: password,
          title: memoryData.title,
          description: memoryData.description,
          date: memoryData.date,
          imageData: memoryData.imageData
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result.memory;
    } catch (error) {
      console.error('Error adding memory via API:', error);
      throw error; // Re-throw so the UI can handle it
    }
  }
  // Delete a memory via API
  async deleteMemory(memoryId, password) {
    try {
      const response = await fetch(this.apiEndpoint, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          password: password,
          memoryId: memoryId
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error deleting memory via API:', error);
      throw error;
    }
  }
}

export default new MemoryService();
